import PaymentPaymentTypes from "enums/PaymentPaymentTypes";

/**
 * The one place a payment method becomes a label.
 *
 * The server sends only ACH and WIRE today; the other two are in the client
 * enum and would otherwise render as raw SCREAMING_CASE if they ever arrived.
 */
const PAYMENT_METHOD_LABEL_KEY: Record<PaymentPaymentTypes, string> = {
  [PaymentPaymentTypes.ACH]: "ACH",
  [PaymentPaymentTypes.WIRE]: "Wire",
  [PaymentPaymentTypes.CHECK]: "Check",
  [PaymentPaymentTypes.CREDIT_CARD]: "Credit Card",
};

/** Only these two reach the payments API; the enum carries two it never sends. */
export const SENT_PAYMENT_METHODS = [
  PaymentPaymentTypes.ACH,
  PaymentPaymentTypes.WIRE,
] as const;

/** A translation KEY, so the caller owns the `t()`. */
export const paymentMethodLabelKey = (
  method: PaymentPaymentTypes | string | null | undefined,
): string | undefined =>
  method ? PAYMENT_METHOD_LABEL_KEY[method as PaymentPaymentTypes] : undefined;
